var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem8A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M377.1 238.5c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6s3.6-5.3 3.6-8.7-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 364.617 252.068)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    1\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M482.4 212.1c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 469.867 225.668)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M535 159.5c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 522.518 173.068)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    3\n  "), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m299.2 196.8-.6 1.3c2.6 1.1 5.2 2.2 7.7 3.3l.4-1.3c-2.4-1.1-4.9-2.2-7.5-3.3m-40.8-27.6-.9 1.1c2.1 1.8 4.2 3.7 6.3 5.5l.9-1.1c-2.1-1.8-4.2-3.6-6.3-5.5m-12.5-10.7c1.8 2 3.7 4 5.7 6.1l.9-1.1c-1.9-1.8-3.8-3.8-5.7-5.9l-.9.9m-9.4-13.8-1.1.7c1.6 2.2 3.3 4.4 5.2 6.6l.9-.9c-1.7-2-3.3-4.1-5-6.4m48.4 44.3-.7 1.1c2.4 1.5 4.8 2.8 7.2 4l.6-1.1c-2.6-1.3-4.9-2.6-7.1-4m-7.7-3.3.7-1.1c-2.4-1.6-4.7-3.2-6.8-4.8l-.7 1.1c2.1 1.6 4.4 3.2 6.8 4.8m85.7 26.5v1.5h8.3v-1.3h-2c-2.1 0-4.2-.1-6.3-.2m-48.8-7.9c2.5.9 5.2 1.8 7.9 2.6l.4-1.3c-2.8-.7-5.4-1.6-7.9-2.6l-.4 1.3m32.4 6.4-.2 1.5c2.8.4 5.5.7 8.3.9l.2-1.5c-2.8-.2-5.5-.5-8.3-.9m-16.2-2.9-.4 1.3c2.8.7 5.5 1.2 8.1 1.7l.4-1.3c-2.7-.6-5.4-1.2-8.1-1.7m120.3-15.5-.7-1.3c-2.4 1.5-4.8 2.8-7.2 3.9l.6 1.3c2.5-1.3 4.9-2.6 7.3-3.9m-14.9 7.4-.6-1.1c-2.5 1-5 2.1-7.5 3.1l.4 1.3c2.6-1 5.1-2.1 7.7-3.3m-48 13.1-.2-1.5c-2.6.3-5.3.6-8.1.7v1.5c2.8-.3 5.5-.5 8.3-.7m32.6-7-.6-1.3c-2.6.7-5.2 1.5-7.9 2.2l.4 1.5 8.1-2.4m-16.2 4.2-.2-1.3c-2.7.6-5.4 1-8.1 1.5l.2 1.5c2.7-.6 5.4-1.2 8.1-1.7m72.6-37.9c-2.1 1.8-4.2 3.5-6.3 5.1l.7 1.1c2.2-1.7 4.4-3.4 6.4-5.1l-.8-1.1m-12.1 11.2-.7-1.1c-2.3 1.6-4.5 3.1-6.8 4.6l.7 1.3c2.2-1.5 4.5-3.1 6.8-4.8m25-21.7-.9-.9-5.9 5.9.9.9c2-1.9 4-3.9 5.9-5.9m10.8-12.7-1.1-.9c-1.7 2.3-3.4 4.4-5.2 6.4l.9.9c1.9-2 3.7-4.1 5.4-6.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M477.1 109.8c-3.2 0-6.3.8-9 2.5l-81.7-59.8c1.4-7.2-.9-13.2-6.8-18-3.2-2.3-6.7-3.4-10.5-3.4-5.7.1-10.4 2.5-14.2 7.3-5.5 9.3-4.2 17.5 3.9 24.6 3.2 2.3 6.7 3.4 10.4 3.3 3.1 0 6.1-.8 8.9-2.4l81.7 59.8c-1.4 7.2.9 13.2 6.8 18 3.2 2.3 6.7 3.4 10.5 3.3 3.2 0 6.2-.8 9-2.4l13.6 1.5-5.5-12.5c1.6-7.4-.7-13.5-6.8-18.4-3.2-2.3-6.6-3.4-10.3-3.4z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M477 108.8c-3.2 0-6.3.8-9 2.4l-80.7-59c.2-1.1.3-2.3.3-3.5-.1-5.9-2.6-10.9-7.5-14.9-3.4-2.5-7.1-3.7-11-3.7-5.9.1-10.9 2.7-14.9 7.7-2.4 3.4-3.6 7.1-3.7 10.9.1 6 2.6 11 7.7 15.1 3.4 2.3 7.1 3.5 10.9 3.5 3.2 0 6.3-.7 9-2.2l80.7 59c-.2 1.1-.3 2.2-.3 3.3.1 6.1 2.6 11.2 7.5 15.1 3.4 2.3 7.1 3.5 11 3.5 3.2.1 6.3-.7 9.2-2.4l14.9 1.7-6-13.8c.3-1.3.5-2.6.5-3.9-.1-6.1-2.6-11.2-7.7-15.1-3.4-2.5-7-3.7-10.9-3.7m0 1.8c3.4 0 6.7 1.1 9.7 3.3 4.7 3.6 7 8.1 7 13.6 0 1.3-.2 2.5-.6 3.7v.4l5.1 11.4-12-1.3h-.6c-2.8 1.7-5.6 2.5-8.6 2.4-3.6.1-6.9-1-9.9-3.1-4.5-3.6-6.7-8.1-6.8-13.6-.1-1.2.1-2.3.4-3.5l.2-.6L378 62.8l-.6.4c-2.6 1.5-5.5 2.2-8.5 2.2-3.4.1-6.7-1-9.7-3.1-4.6-3.6-6.9-8.2-7-13.6 0-3.4 1.1-6.7 3.3-9.7 3.6-4.7 8-7 13.4-7 3.6 0 6.9 1.1 9.9 3.3 4.5 3.6 6.7 8 6.8 13.4.1 1.3-.1 2.5-.4 3.7l-.2.6 82.8 60.5.6-.4c2.8-1.6 5.6-2.4 8.6-2.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 94.458,
    cy: 140.286,
    r: 5.85,
    gradientTransform: "matrix(1.8393 0 0 -1.8392 195.474 306.752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.4 40.3c-2-1.3-4.1-2-6.3-2-3.3 0-6 1.4-8.2 4.1-3.2 5.5-2.5 10.3 2.2 14.5 1.8 1.3 3.9 2 6.2 2 3.4 0 6.2-1.4 8.4-4.1 3.1-5.6 2.3-10.4-2.3-14.5z",
    style: {
      fill: "url(#a)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M375.8 39.6c-2.1-1.5-4.4-2.2-6.8-2.2-3.6-.1-6.6 1.5-9 4.6-1.5 2.1-2.2 4.3-2.2 6.6 0 3.7 1.5 6.7 4.6 9.2 2.1 1.5 4.4 2.2 6.6 2.2 3.7-.1 6.8-1.6 9.2-4.6 1.5-2.1 2.2-4.4 2.2-6.8 0-3.7-1.6-6.7-4.6-9m-6.8-.2c2 0 3.9.6 5.5 1.7 2.6 2.1 3.9 4.6 3.9 7.5.1 2-.6 3.9-1.8 5.5-2 2.6-4.5 3.9-7.5 3.9-1.8 0-3.7-.6-5.5-1.8-2.4-2-3.6-4.5-3.7-7.5 0-1.9.6-3.7 1.7-5.5 1.9-2.5 4.4-3.8 7.4-3.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M481.1 121.6c-1.2-.9-2.5-1.3-4-1.3-2.4 0-4.3 1-5.8 2.9-2.3 3.7-1.8 6.9 1.5 9.7 1.3.9 2.8 1.4 4.2 1.4 2.3 0 4.2-1 5.7-2.9 2.2-3.5 1.7-6.8-1.6-9.8z",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M484.8 127.4c-.1-2.5-1.1-4.7-3.1-6.4-1.5-.9-3.1-1.4-4.6-1.5-2.6 0-4.7 1.1-6.3 3.3-1 1.4-1.5 2.9-1.5 4.4 0 2.5 1 4.7 3.1 6.4 1.3 1 2.9 1.5 4.6 1.5 2.5 0 4.6-1.1 6.3-3.3.9-1.3 1.4-2.8 1.5-4.4m-4-5.3c1.7 1.4 2.5 3.2 2.6 5.3 0 1.3-.4 2.6-1.1 3.7-1.5 1.7-3.2 2.6-5.2 2.6-1.4.1-2.7-.4-3.9-1.3-1.7-1.2-2.6-2.9-2.6-5.1-.1-1.3.4-2.5 1.3-3.7 1.3-1.7 3.1-2.5 5.2-2.6 1.3 0 2.5.3 3.7 1.1zM370.7 227.4v-14.3h-4.2v14.3h4.2zm95.3-28.7-7.5-12.1-3.5 2.2 7.5 12.1 3.5-2.2zm48.6-46.4-11.6-8.5-2.4 3.3 11.6 8.5 2.4-3.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem8A);
export default __webpack_public_path__ + "static/media/item8a.4228dd2dcf1ccc048c60b7e3e402e575.svg";
export { ForwardRef as ReactComponent };